<template>
  <div class="page" v-loading="detailLoading">
    <div class="content">
      <!-- 头部 -->
      <Step :active="2" />
      <!-- 基本信息 -->
      <div class="base-info">
        <h2 class="title">基本信息：</h2>
        <div class="base-list">
          <div class="base-item">
            <div class="base-label">客户企业：</div>
            <div class="base-value">
              {{ dataForm.companyName }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label required">最终客户名称：</div>
            <div class="base-value">
              <el-select
                size="mini"
                style="width: 100%"
                v-model="dataForm.finalCompanyName"
                filterable
                remote
                reserve-keyword
                placeholder="请输入企业名称"
                @change="onCompanyChange"
                :remote-method="companyRemoteMethod"
                :loading="companyLoading"
                clearable
              >
                <el-option
                  v-for="i in companyOptions"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                />
              </el-select>
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">最终客户统一社会信用代码：</div>
            <div class="base-value">
              {{ dataForm.finalSocialCreditCode }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">客户合同号：</div>
            <div class="base-value">
              <el-input
                style="width: 100%"
                placeholder="请输入"
                v-model="dataForm.customerContractCode"
                size="mini"
                maxlength="100"
              />
            </div>
          </div>
          <div class="base-item">
            <div class="base-label required">项目名称：</div>
            <div class="base-value">
              <el-input
                style="width: 100%"
                placeholder="请输入"
                v-model="dataForm.projectName"
                size="mini"
                maxlength="100"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 收货地址 -->
      <Address
        :companyId="dataForm.companyId"
        ref="address"
        v-if="dataForm.companyId"
      />
      <!-- 商品明细 -->
      <div class="items-wrap">
        <div class="title-wrap">
          <h2 class="title">商品明细：</h2>
        </div>
        <ItemList :tableData="dataForm.itemList" />
        <!-- 底部内容 -->
        <div class="plc-bottom">
          <div class="plc-pagination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 底部信息 -->
      <div class="bottom">
        <div class="bottom-price">
          <div>
            商品应付含税总额（元）：<span class="red"
              >￥{{ dataForm.totalPay | formatePrice }}</span
            >
          </div>
          <div>
            标准金额小计(元)：<span
              >￥{{ dataForm.payMoney | formatePrice }}</span
            >
          </div>
          <div>
            折扣优惠(元)：
            <span
              >￥{{
                Math.abs(dataForm.discountMoney || 0) | formatePrice
              }}</span
            >
          </div>
        </div>
        <div class="bottom-btns">
          <div class="total-price">
            <span>应付含税总额(元)： </span>
            <span class="red">￥{{ dataForm.totalPay | formatePrice }}</span>
          </div>
          <div class="btn" :loading="loading" @click="() => saveOrder(false)">
            保存订单
          </div>
          <div class="btn" :loading="loading" @click="() => saveOrder(true)">
            提交订单
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from './order/step'
import ItemList from './order/itemList'
import Address from './order/address'
import { Base64 } from 'js-base64'
import { formatePrice } from '@/utils/formatePrice'

export default {
  components: {
    Step,
    ItemList,
    Address
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      dataForm: {
        companyId: '',
        companyName: '',
        finalSocialCreditCode: '',
        finalCompanyName: '',
        customerContractCode: '',
        projectName: '',
        itemList: [],
        payMoney: 0,
        discountMoney: 0,
        totalPay: 0
      },
      companyOptions: [],
      companyLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      plcUserInfo: JSON.parse(sessionStorage.getItem('plcUserInfo') || '{}'),
      detailLoading: false
    }
  },
  methods: {
    init () {
      const { t, id } = this.$route.query
      if (id) {
        // 走编辑逻辑
        return this.getDetail()
      }
      if (t) {
        // 走新增逻辑
        this.setAddInfo(t)
      }
    },
    getDetail () {
      const id = Base64.decode(this.$route.query.id)
      this.detailLoading = true
      this.$http
        .post('/front/oms/plc/user/queryOrderDetail', { id })
        .then(({ data: res }) => {
          this.detailLoading = false
          if (res.code === 0) {
            Object.keys(this.dataForm).forEach((key) => {
              this.dataForm[key] = res.data[key]
            })
            this.companyOptions = [
              {
                label: res.data.finalCompanyName,
                value: res.data.finalSocialCreditCode
              }
            ]
            // 设置地址
          }
        })
    },
    setAddInfo (t) {
      const info = JSON.parse(sessionStorage.getItem('plcOrderAdd') || '{}')
      if (info.t + '' === t) {
        this.dataForm.itemList = info.itemList
        this.setFrontPage(this.dataForm.itemList)
      }
      this.dataForm.companyId = this.plcUserInfo.defaultCompanyId
      this.dataForm.companyName = this.plcUserInfo.defaultCompanyName
    },
    onCompanyChange (res) {
      const val = (this.companyOptions || []).find((i) => i.companyName === res)
      this.dataForm.finalSocialCreditCode = val.socialCreditCode
      const obj = {
        ...this.dataForm
      }
      this.$http
        .post('/front/oms/plc/user/getConfirmOrderInfo', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm = {
              ...this.dataForm,
              itemList: res.data.itemList,
              discountMoney: res.data.discountMoney,
              payMoney: res.data.payMoney,
              totalPay: res.data.totalPay
            }
          }
        })
    },
    companyRemoteMethod (str) {
      if (!str) return
      this.companyLoading = true
      this.$http
        .get(
          `/inter/qixinbao/fuzzyQueryByKeyword?keyword=${str}&matchType=ename&region=&skip=`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.companyOptions = res.data.map((item) => {
              return {
                ...item,
                label: item.companyName,
                value: item.companyName
              }
            })
          }
        })
        .finally(() => {
          this.companyLoading = false
        })
    },
    // 前端分页
    setFrontPage (data) {
      this.total = data.length
      this.currentPage = 1
      this.frontData = [...data]
      this.getFrontPage()
    },
    getFrontPage () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = this.currentPage * this.pageSize
      this.dataForm.itemList = this.frontData.slice(start, end) // slice() 方法不会改变原始数组
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getFrontPage()
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getFrontPage()
    },
    saveOrder (submit) {
      if (!this.dataForm.finalCompanyName) {
        this.$message.warning('请选择最终客户')
        return
      }
      if (!this.dataForm.projectName) {
        this.$message.warning('请输入项目名称')
        return
      }
      const receiveAddress = this.$refs.address.getResult()
      if (!receiveAddress || !receiveAddress.id) {
        this.$message.warning('请选择收货地址')
        return
      }
      const obj = {
        ...this.dataForm,
        receiveAddress,
        submit
      }
      console.log(obj)
      this.loading = true
      this.$http
        .post('/front/oms/plc/user/creatOrder', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.$router.push({
              path: '/plcOrderDetail',
              query: {
                id: Base64.encode(res.data)
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  overflow: auto;
  padding-bottom: 28px;
}

.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;
}

.title {
  display: flex;
  font-size: 16px;
  margin: 0;
  color: #000000;
}

.base-info {
  background: #fff;
  margin-top: 16px;
  padding: 16px 28px;
  border-radius: 12px;
  .base-list {
    display: flex;
    flex-wrap: wrap;
    .base-item {
      display: flex;
      align-items: center;
      width: 33.33%;
      margin-top: 8px;
    }
    .base-label {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #3d3d3d;
      &.required::before {
        display: inline-block;
        content: '*';
        margin-right: 2px;
        font-size: 14px;
        color: #e93037;
      }
    }
    .base-value {
      padding-right: 28px;
      flex: 1;
    }
  }
}

.items-wrap {
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
}

.title-wrap {
  padding: 16px 28px;
}

.bottom {
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
  .red {
    color: #e93037;
    font-weight: 900;
    font-size: 20px;
  }
  .bottom-price {
    text-align: right;
    padding: 16px 28px;
    font-size: 16px;
    color: #666666;
    > div {
      padding-bottom: 8px;
    }
  }
  .bottom-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #efeff2;
    padding: 10px 28px;
    .total-price {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 12px;
    }
    .btn {
      min-width: 95px;
      height: 36px;
      padding: 8px 12px;
      border-radius: 8px;
      background: #2a54d1;
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      color: #ffffff;
      margin-left: 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.save {
        background: rgba(42, 84, 209, 0.4);
      }
    }
  }
}
</style>
